/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsApplicationBase {
    getFixupPrototypeFunction() { return AppSecopsApplicationBase.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsApplicationBase>): AppSecopsApplicationBase {
        let obj = Object.assign(new AppSecopsApplicationBase(), model);
        AppSecopsApplicationBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsApplicationBase>): AppSecopsApplicationBase {
        if (!model) return null;
        return AppSecopsApplicationBase.newInstance(<AppSecopsApplicationBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsApplicationBase) {
        if (!obj) return;

        models.AppSecopsApplicationBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsApplicationBase): boolean {
        Object.setPrototypeOf(obj, AppSecopsApplicationBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.business_criticality === undefined) {
            this.business_criticality = 0;
        }
        if (this.tags) {
            for (let val of this.tags) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * Name of the application
     */
    name: string;

    /**
     * Owners of the application
     */
    owner: Array<string>;

    /**
     * Indicates the application's importance to the business in terms of criticality.
     */
    business_criticality: number;

    /**
     * Description of the application
     */
    description: string;

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * Portfolio to which the application belongs.
     */
    portfolio_id: string;

    /**
     * Application Deployed DevTool
     */
    dev_tool: models.DevToolName;

    /**
     * Cloud Provider to select
     */
    service_name: models.AppSecopsApplicationCloudProvider;

    tags: Array<models.KeyValuePair>;

    /**
     * List of workload ids to which the application belongs.
     */
    workload_ids: Array<string>;

}
